import tippy from 'tippy.js'
;(() => {
  const activateSpinokoPopovers = () => {
    tippy('[data-terms] button', {
      content(reference) {
        const textWrapper = reference.parentElement.parentElement.querySelector('.terms-content')
        return textWrapper ? textWrapper.innerText : ''
      },
      // @see spinoko_scripts() in `inc/setup/enqueue-assets.php`
      placement: SpinokoFrontEnd.termsPopoverPosition, // eslint-disable-line
      interactive: true,
      arrow: true,
      allowHTML: false,
    })

    tippy('[data-games] button', {
      content(reference) {
        const textWrapper = reference.parentElement.parentElement.querySelector('.games-content')
        return textWrapper ? textWrapper.innerHTML : ''
      },
      // @see spinoko_scripts() in `inc/setup/enqueue-assets.php`
      placement: SpinokoFrontEnd.termsPopoverPosition, // eslint-disable-line
      interactive: true,
      arrow: true,
      allowHTML: true,
    })
  }

  window.tippy = tippy
  window.activateSpinokoPopovers = activateSpinokoPopovers

  activateSpinokoPopovers()
})()
